
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__graduation-cap",
  "use": "icon__graduation-cap-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon__graduation-cap\"><path d=\"M8 1.96 0 5.165V13h1V6.578l2 .703v4.25l.242.149S5.41 13 8 13s4.758-1.32 4.758-1.32L13 11.53v-4.25l3-1.05V5.163L8 1.961Zm0 1.08 6.578 2.628L8 7.968l-6.578-2.3L8 3.039ZM4 7.628 8 9.03l.164-.058L12 7.633v3.297c-.328.183-1.969 1.07-4 1.07-2.031 0-3.672-.887-4-1.07V7.629ZM.5 14c-.277 0-.5.223-.5.5s.223.5.5.5.5-.223.5-.5-.223-.5-.5-.5Z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconGraduationCapIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__graduation-cap" {...restProps} />
    })
  